import {
  Modal,
  ModalContent,
  ModalOverlay,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
} from '@chakra-ui/react';

type CheckoutErrorModalProps = {
  isOpen: boolean;
  title: string;
  message: string;
  onClose: () => void;
};

export default function CheckoutErrorModal({
  isOpen,
  title,
  message,
  onClose,
}: CheckoutErrorModalProps) {
  return (
    <Modal size="xs" isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        {title && (
          <ModalHeader fontSize="lg" textAlign="center" pb={0}>
            {title}
          </ModalHeader>
        )}
        <ModalBody p={4}>
          <Text textAlign="center" fontSize="sm">
            {message}
          </Text>
        </ModalBody>
        <ModalFooter p={0} borderColor="gray.400" borderTopWidth="1px">
          <Button isFullWidth variant="unstyled" fontWeight="normal" onClick={onClose}>
            我知道了
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
